import React from "react"
import {Link} from "gatsby"
import { RiHeart2Line } from "react-icons/ri";

const Footer = () => (
  <footer className="site-footer">
    <div className="container">
      <p><span className="icon -love"><RiHeart2Line/></span><Link to="/">Lang-Lang-Lang</Link></p>
    </div>
  </footer>
)

export default Footer